import React from "react"
import Img from "gatsby-image"

import font from "../../fonts/fonts.module.scss"
import styled from "styled-components"

import {  I18nextContext } from 'gatsby-plugin-react-i18next'

// import filter from "../../images/vinhoCardFilter.svg"

const VinhoCard = ({ data }) => {
  const activeLanguage = React.useContext(I18nextContext).language

  return (
    <StyledVinho>
      <div className="cardContent">
        <Img fluid={data.img.childImageSharp.fluid} style={{ width: `80%` }} imgStyle={{ objectFit: "contain" }} className="vinhoImg" />
        <h4 className={font.nSR + " cardTitle"}>{data.nome}</h4>
        {data.ano !== "---" && <p className={font.uR + " cardYear"}>{data.ano}</p>}
        {activeLanguage === 'pt' ? <p className={font.uR + " cardEsgotado"}>{data.esgotado_pt}</p>:
          activeLanguage === 'en' ? <p className={font.uR + " cardEsgotado"}>{data.esgotado_en}</p> :
            activeLanguage === 'fr' && <p className={font.uR + " cardEsgotado"}>{data.esgotado_fr}</p>}
      </div>
    </StyledVinho>
  )
}

export default VinhoCard

const StyledVinho = styled.div`
  position: relative;
  height: 100%;
  background: rgb(62,48,40);
  background: linear-gradient(180deg, rgba(62,48,40,1) 0%, rgba(62,48,40,1) 50%, rgba(31,24,19,1) 100%);

  .backgroundFilter{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    opacity: 0.35;
  }

  .cardContent{
    width: 90%;
    margin: auto;
    padding: 30px 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: #fff9f4;

    .cardTitle{
      margin-top: 20px;
      height: 2em;
      font-size:20px !important;
    }

    .cardYear{
      font-size: 14px !important;
      margin-top: 10px;
    }

    .cardEsgotado{
      font-size: 14px !important;
      margin-top: 10px;
      color: #ff466b;
    }
  }
`